//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[],[[[],"GetRotarySolutionType",{R_:{rotarySolutionType:''}},0,0],[["rotarySolutionType"],"SetRotarySolutionType",{},1,0],[[],"GetSolutionCheckedState",{R_:{solutionCheckedState:''}},0,0],[["solutionCheckedState"],"SetSolutionCheckedState",{},1,0],[[],"GetRotarySolutionInheritStatus",{R_:{rotarySolutionInheritStatus:''}},0,0],[["rotarySolutionInheritStatus"],"SetRotarySolutionInheritStatus",{},1,0]],[]];
SPLM.CAM.ChainRotarySolutionBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ChainRotarySolutionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ChainRotarySolutionBuilder.RotarySolutionType = Object.freeze({
    "SolutionOne" : "SolutionOne", "SolutionTwo" : "SolutionTwo"});

SPLM.CAM.ChainRotarySolutionBuilder.SolutionCheckedState = Object.freeze({
    "Off" : "Off", "On" : "On"});

SPLM.CAM.ChainRotarySolutionBuilder.RotarySolutionInheritStatus = Object.freeze({
    "Local" : "Local", "Inherited" : "Inherited"});

export default SPLM;